import React from 'react';
import { connect } from 'react-redux';
// Color picker imports
import ColorPicker from '../../Default/ColorPicker';
// Game(kit) imports
import gameKit from '../../../../GameKit';

import settings from '../../../../settings';

import BackgroundNav from './nav';

class Background extends React.Component {
    onFirstColorPick = color => {
        const colorValue = parseInt(color, 16);
        gameKit.levelEditor.updateLevelSettings({
            backgroundColorA: colorValue
        });
    };

    onSecondColorPick = color => {
        const colorValue = parseInt(color, 16);
        gameKit.levelEditor.updateLevelSettings({
            backgroundColorB: colorValue
        });
    };

    render() {
        const { closeSideBar, levelSettings, activeItem, handleSelectColor, handleSelectDraw, handleSelectErase, activeBlockUrl } = this.props;

        return (
            <>
                <BackgroundNav
                    activeBlockUrl={activeBlockUrl}
                    activeItem={activeItem}
                    handleSelectColor={handleSelectColor}
                    handleSelectDraw={handleSelectDraw}
                    handleSelectErase={handleSelectErase}
                />
                <div className="side-bar-header">
                    <div className="side-bar-header-col side-bar-header-text">Achtergrond</div>
                    <div className="side-bar-header-col side-bar-header-close" onClick={closeSideBar} role="none">
                        <img src={`${settings.assetsPath}img/icons/bouwsteen-sluit.png`} alt="Sluiten" title="Sluiten" />
                    </div>
                </div>
                <hr className="side-bar-hr" />
                <div className="side-bar-page-content">
                    <div className="side-bar-row side-bar-row-title">
                        <span>Bovenste kleur</span>
                    </div>
                    <div className="side-bar-row" style={{ margin: '0 auto' }}>
                        <ColorPicker color={`${levelSettings.backgroundColorA.toString(16).padStart(6, '0')}`} onChange={this.onFirstColorPick} />
                    </div>
                    <div className="side-bar-row side-bar-row-title">
                        <span>Onderste kleur</span>
                    </div>
                    <div className="side-bar-row" style={{ margin: '0 auto' }}>
                        <ColorPicker color={`${levelSettings.backgroundColorB.toString(16).padStart(6, '0')}`} onChange={this.onSecondColorPick} />
                    </div>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    blokEditor: state.blokEditor,
    levelSettings: state.levelSettings,
    sideBar: state.sideBar
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Background);
